import { renderDsTabs } from '../../../../../shared-ui/ds/tabs.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

const TABS_STATES = new Set(['Default', 'Hover', 'Active', 'Focus', 'Disabled', 'Loading']);
const TABS_SIZES = new Set(['sm', 'md', 'lg']);

export function renderSettingsTabs(options = {}) {
  const normalized = withSettingsPresentationMode(options);
  const rawTabs = Array.isArray(normalized.tabs) ? normalized.tabs : [];
  const tabs = rawTabs.map((tab, index) => normalizeTab(tab, index));
  const activeId = String(normalized.activeId || '').trim();
  const activeIndex = tabs.findIndex((tab) => tab.id === activeId);
  const state = TABS_STATES.has(normalized.state)
    ? normalized.state
    : 'Active';
  const size = TABS_SIZES.has(normalized.size)
    ? normalized.size
    : 'sm';
  const className = [
    String(normalized.className || '').trim(),
    'kg-settings-tabs',
    normalized.navOnly === false ? '' : 'kg-settings-tabs--nav-only'
  ].filter(Boolean).join(' ');

  const html = renderDsTabs({
    ...normalized,
    state,
    size,
    tabVariant: normalized.tabVariant,
    className,
    tabs: tabs.map((tab) => ({ id: tab.id, label: tab.label })),
    activeIndex: activeIndex >= 0 ? activeIndex : 0,
    panelHtml: normalized.panelHtml == null ? '' : String(normalized.panelHtml)
  });

  let tabIndex = 0;
  return html.replace(/<button type="button" class="([^"]*)"([^>]*)>([\s\S]*?)<\/button>/g, (match, classValue, rest, labelHtml) => {
    const tab = tabs[tabIndex];
    tabIndex += 1;
    if (!tab) return match;
    return `<button type="button" class="${escapeAttribute(classValue)}"${renderAttributeMap(tab.attrs)}${rest}>${labelHtml}</button>`;
  });
}

function normalizeTab(tab, index) {
  if (typeof tab === 'string') {
    return {
      id: `tab-${index}`,
      label: tab,
      attrs: {}
    };
  }

  const normalized = tab && typeof tab === 'object' ? tab : {};
  return {
    id: String(normalized.id || `tab-${index}`),
    label: String(normalized.label || normalized.title || `Tab ${index + 1}`),
    attrs: normalized.attrs && typeof normalized.attrs === 'object'
      ? { ...normalized.attrs }
      : {}
  };
}

function renderAttributeMap(attrs = {}) {
  if (!attrs || typeof attrs !== 'object') return '';
  return Object.entries(attrs).map(([key, value]) => {
    const name = String(key || '').trim();
    if (!name || value == null || value === false) return '';
    if (value === true) return ` ${name}`;
    return ` ${name}="${escapeAttribute(String(value))}"`;
  }).join('');
}

function escapeAttribute(value = '') {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
